import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Initialize Sentry before React renders.
// VITE_SENTRY_DSN is empty in local dev - Sentry is a no-op.
const _sentryDsn = import.meta.env.VITE_SENTRY_DSN || ''
if (_sentryDsn) {
  Sentry.init({
    dsn: _sentryDsn,
    release: import.meta.env.VITE_SENTRY_RELEASE || 'unknown',
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  })
}
import { initDevErrorCapture } from '@/lib/dev-error-capture'
initDevErrorCapture()
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import App from './App'
import { queryClient } from './queryClient'
import '@/index.css'

// Self-hosted fonts (replaces the Google Fonts CDN link in index.html).
// Only the weights actually used in the app are imported to minimize bytes.
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import '@fontsource/jetbrains-mono/600.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: '#0C0C10', color: '#E0E0EC', border: '1px solid #1E1E2A' },
          }}
        />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
)
